import { BehaviorSubject, from, Subject } from 'rxjs';
import * as R from 'ramda';
import { filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { mapValidationSchema, mapValidationErrors } from '../utils/validation.utils';
var FormValidator = /** @class */ (function () {
    function FormValidator(context) {
        var _this = this;
        this.context = context;
        this.validation$ = new BehaviorSubject(null);
        this.validating$ = new BehaviorSubject(false);
        this.destroy$ = new Subject();
        this.setErrors = function (errors) {
            return _this.context.setErrors(errors);
        };
        this.afterValidation$ = function () { return _this.validating$.pipe(filter(R.not)); };
        this.validation$
            .pipe(filter(R.complement(R.isNil)), tap(function () { return _this.validating$.next(true); }), switchMap(function (values) {
            var validator = mapValidationSchema(_this.validatorFrame, _this.formulaDef);
            var validationResult = validator
                .validate(values, { abortEarly: false })
                .then(R.always({}), mapValidationErrors);
            return from(validationResult); // .pipe(delay(FormContext.CHANGE_DEBOUNCE_TIME));
        }), tap(function () { return _this.validating$.next(false); }), takeUntil(this.destroy$))
            .subscribe(this.setErrors);
    }
    Object.defineProperty(FormValidator.prototype, "formulaDef", {
        get: function () {
            return this.context.formulaDefinition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormValidator.prototype, "isValidating", {
        get: function () {
            return this.validating$.getValue();
        },
        enumerable: true,
        configurable: true
    });
    FormValidator.prototype.updateFrame = function (frame) {
        this.validatorFrame = frame;
    };
    FormValidator.prototype.validate = function (values) {
        var _this = this;
        setImmediate(function () { return _this.validation$.next(values); });
    };
    FormValidator.prototype.destroy = function () {
        this.destroy$.next();
    };
    return FormValidator;
}());
export { FormValidator };
//# sourceMappingURL=form-validator.js.map